const headerSectionVariants = ['v1'];
const bannerSectionVariants = ['v1'];
const comparisunHeroSectionVariants = [
    'comparisunV1',
    'comparisunV2',
];
const leadsLiveHeroSectionVariants = ['leadsLiveV1'];
const betterspeechHeroSectionVariants = [
    'betterspeechV1',
    'betterspeechV2',
];
const firstConnectHeroSectionVariants = ['fcV1'];
const z2aHeroSectionVariants = ['z2aV1', 'z2aV2'];
const harelHeroSectionVariants = ['harelV1', 'harelV2', 'harelV3'];
const heroSectionVariants = [
    'v1',
    'v2',
    'v3',
    'v4',
    'v5',
    'v6',
    'v7',
    'v8',
    'v9',
    'v10',
    'v11',
    'v12',
];
const ctaSectionVariants = ['v1', 'v2', 'v3', 'v4'];
const betterspeechCTASectionVariants = [
    'betterspeechV1',
    'betterspeechV2',
];
const logosSectionVariants = [
    'v1',
    'v2',
    'v3',
    'v4',
    'v5',
    'v6',
];
const z2aLogosSectionVariants = ['z2aV1'];
const trustpilotSectionVariants = ['v1'];
const featuresSectionVariants = ['v1', 'v2', 'v3', 'v4'];
const z2aFeaturesSectionVariants = ['z2aV1'];
const textImageSectionVariants = ['v1', 'v2', 'v3', 'v4'];
const textSectionVariants = ['v1'];
const comparisunTextSectionVariants = ['comparisunV1'];
const testimonialsSectionVariants = [
    'v1',
    'v2',
    'v3',
    'v4',
    'v5',
    'v6',
];
const pressMentionsSectionVariants = ['v1'];
const comparisunComparisonTopItemsSectionVariants = [
    'comparisunV1',
    'comparisunV2',
    'comparisunV3',
    'comparisunV4',
];
const comparisonTopItemsSectionVariants = ['v1'];
const comparisunComparisonListSectionVariants = [
    'comparisunV1',
    'comparisunV2',
    'comparisunV3',
    'comparisunV4',
    'comparisunV5',
    'comparisunV6',
    'comparisunV7',
];
const leadsLiveComparisonListSectionVariants = ['leadsLiveV1'];
const z2aComparisonListSectionVariants = ['z2aV1', 'z2aV2'];
const comparisonListSectionVariants = ['v1'];
const categoriesSectionVariants = ['v1', 'v2'];
const betterspeechShowcaseSectionVariants = ['betterspeechV1'];
const z2aShowcaseSectionVariants = ['z2aV1'];
const showcaseSectionVariants = ['v1', 'v2', 'v3'];
const calendlySectionVariants = ['v1'];
const formSectionVariants = ['v1', 'v2'];
const faqsSectionVariants = ['v1', 'v2', 'v3', 'v4', 'v5'];
const comparisunFaqsSectionVariants = ['comparisunV1'];
const z2aFaqsSectionVariants = ['z2aV1'];
const customCodeSectionVariants = ['v1'];
const customHTMLSectionVariants = ['v1'];
const footerSectionVariants = ['v1'];
const comparisunFooterSectionVariants = ['comparisunV1'];
const topComparedFooterSectionVariants = ['topComparedV1'];
const z2aFooterSectionVariants = ['z2aV1'];
const sectionTypeToVariantMapping = {
    header: headerSectionVariants,
    banner: bannerSectionVariants,
    features: featuresSectionVariants,
    textImage: textImageSectionVariants,
    text: textSectionVariants,
    testimonials: testimonialsSectionVariants,
    form: formSectionVariants,
    faqs: faqsSectionVariants,
    footer: footerSectionVariants,
    hero: heroSectionVariants,
    cta: ctaSectionVariants,
    calendly: calendlySectionVariants,
    logos: logosSectionVariants,
    code: customCodeSectionVariants,
    html: customHTMLSectionVariants,
    categories: categoriesSectionVariants,
    showcase: showcaseSectionVariants,
    pressMentions: pressMentionsSectionVariants,
    comparisonList: comparisonListSectionVariants,
    comparisonTopItems: comparisonTopItemsSectionVariants,
    trustpilot: trustpilotSectionVariants,
    quinstreetList: ['v1'],
};
const accountSectionTypeToVariantMapping = {
    // Comparisun
    'deDjFxdKX7qLdBALhQ2B': {
        hero: comparisunHeroSectionVariants,
        comparisonList: comparisunComparisonListSectionVariants,
        comparisonTopItems: comparisunComparisonTopItemsSectionVariants,
        text: comparisunTextSectionVariants,
        faqs: comparisunFaqsSectionVariants,
        footer: comparisunFooterSectionVariants,
    },
    // Top Compared
    '9tVzCC1soqRMWdzUzrE9': {
        hero: comparisunHeroSectionVariants,
        comparisonList: comparisunComparisonListSectionVariants,
        comparisonTopItems: comparisunComparisonTopItemsSectionVariants,
        text: comparisunTextSectionVariants,
        faqs: comparisunFaqsSectionVariants,
        footer: topComparedFooterSectionVariants,
    },
    // Comparison Test
    'kb1yrghwEBZBhCyLzr1E': {
        hero: comparisunHeroSectionVariants,
        comparisonList: comparisunComparisonListSectionVariants,
        comparisonTopItems: comparisunComparisonTopItemsSectionVariants,
        text: comparisunTextSectionVariants,
        faqs: comparisunFaqsSectionVariants,
        footer: comparisunFooterSectionVariants,
    },
    // LeadsLive
    'RTZtYb5dyMkj1wJ549Hz': {
        hero: leadsLiveHeroSectionVariants,
        comparisonList: leadsLiveComparisonListSectionVariants,
    },
    'Cyder_ai': {
        hero: comparisunHeroSectionVariants,
        comparisonList: comparisunComparisonListSectionVariants,
        comparisonTopItems: comparisunComparisonTopItemsSectionVariants,
        footer: comparisunFooterSectionVariants,
    },
    // Z2A Digital
    'feIW1OiWAk8RQ9hzGeML': {
        hero: z2aHeroSectionVariants,
        comparisonList: z2aComparisonListSectionVariants,
        faqs: z2aFaqsSectionVariants,
        logos: z2aLogosSectionVariants,
        features: z2aFeaturesSectionVariants,
        showcase: z2aShowcaseSectionVariants,
        footer: z2aFooterSectionVariants,
    },
    // Harel
    'ccjBxzBLrRObtOFMVUTr': {
        hero: harelHeroSectionVariants,
    },
    // First Connect
    'jmbSdkB9Kviy18Ew2Zce': {
        hero: firstConnectHeroSectionVariants,
    },
    // Betterspeech
    '1e9MMBdoQsMz5D6jeU7a': {
        hero: betterspeechHeroSectionVariants,
        cta: betterspeechCTASectionVariants,
        showcase: betterspeechShowcaseSectionVariants,
    },
};

export { accountSectionTypeToVariantMapping, bannerSectionVariants, betterspeechCTASectionVariants, betterspeechHeroSectionVariants, betterspeechShowcaseSectionVariants, calendlySectionVariants, categoriesSectionVariants, comparisonListSectionVariants, comparisonTopItemsSectionVariants, comparisunComparisonListSectionVariants, comparisunComparisonTopItemsSectionVariants, comparisunFaqsSectionVariants, comparisunFooterSectionVariants, comparisunHeroSectionVariants, comparisunTextSectionVariants, ctaSectionVariants, customCodeSectionVariants, customHTMLSectionVariants, faqsSectionVariants, featuresSectionVariants, firstConnectHeroSectionVariants, footerSectionVariants, formSectionVariants, harelHeroSectionVariants, headerSectionVariants, heroSectionVariants, leadsLiveComparisonListSectionVariants, leadsLiveHeroSectionVariants, logosSectionVariants, pressMentionsSectionVariants, sectionTypeToVariantMapping, showcaseSectionVariants, testimonialsSectionVariants, textImageSectionVariants, textSectionVariants, topComparedFooterSectionVariants, trustpilotSectionVariants, z2aComparisonListSectionVariants, z2aFaqsSectionVariants, z2aFeaturesSectionVariants, z2aFooterSectionVariants, z2aHeroSectionVariants, z2aLogosSectionVariants, z2aShowcaseSectionVariants };
//# sourceMappingURL=section.esm.js.map
